export const canRetry = (context, event) => {
  return context.retryRefreshAttempts < 3;
};
